import { render, staticRenderFns } from "./EditAccountView.vue?vue&type=template&id=85b0464e&"
import script from "./EditAccountView.vue?vue&type=script&lang=js&"
export * from "./EditAccountView.vue?vue&type=script&lang=js&"
import style0 from "./EditAccountView.vue?vue&type=style&index=0&id=85b0464e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports